import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=e42ec0fe"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e42ec0fe')) {
      api.createRecord('e42ec0fe', component.options)
    } else {
      api.reload('e42ec0fe', component.options)
    }
    module.hot.accept("./Summary.vue?vue&type=template&id=e42ec0fe", function () {
      api.rerender('e42ec0fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/checkout/components/single/Summary.vue"
export default component.exports